// angular
import {
  Component,
  OnChanges,
  booleanAttribute,
  forwardRef,
  input,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-checkbox',
  standalone: true,
  imports: [TranslateModule, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckBoxComponent),
      multi: true,
    },
  ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
})
export class CheckBoxComponent implements OnChanges {
  public value: string | null = null;
  public disabled = false;
  private _checked!: boolean;

  // inputs
  label = input<string>('');
  id = input<number | string>();
  isDisabled = input<boolean>(false);
  isChecked = input<boolean>(false);
  embedded = input(false, { transform: booleanAttribute });

  ngOnChanges(): void {
    if (this.isChecked()) {
      this._checked = this.isChecked();
    }
  }

  get checked(): boolean {
    return this._checked;
  }

  set checked(value: boolean) {
    this._checked = value;
    this.propagateChange(this._checked);
  }

  propagateChange = (_: boolean) => {};

  writeValue(value: boolean): void {
    this._checked = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(): void {}
}
